var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{on:{"change":function($event){return _vm.userStateChange(_vm.userinfo)}},model:{value:(_vm.nowState),callback:function ($$v) {_vm.nowState=$$v},expression:"nowState"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }